import { isNull } from "lodash";
import { icons } from "../../features/NetSpace/NetSpaceConstant";

export const messageConfig = (revokeDetails) => ({
  dataSource: () => {
    const icon = icons[revokeDetails.dataSourceType];
    return (
      <div>
        Please confirm the redaction of the public link for all files in the{" "}
        <span className="revoke-message-datasource">
          {revokeDetails.dataSource}
          <img
            className="revoke-popup-img"
            src={icon}
            alt={revokeDetails.dataSource}
          />
        </span>{" "}
      </div>
    );
  },
  dataMapContents: () => (
    <div>
      Please confirm the redaction of the public link for the selected files{" "}
      <br />
      <span className="revokeDetailsCount">{`( ${revokeDetails.count} ).`}</span>
    </div>
  ),
  behavioralAnomalies: () => (
    <div>
      Please confirm if this alert needs to be escalated into an incident.
      <br />
    </div>
  ),
  dataMapTable: () => (
    <div>
      Please confirm the redaction of the public link for the selected file{" "}
      <span className="revoke-second-title">
        {!isNull(revokeDetails) ? revokeDetails.fileName : ""}
      </span>
      .
    </div>
  ),

  default: () => (
    <div>
      Please confirm the redaction of the public link on all files for the user{" "}
      <br />
      <span className="revoke-second-title">
        {!isNull(revokeDetails) ? revokeDetails.userName : ""}
      </span>
      .
    </div>
  ),
});

export const toggleUserInList = (list, user) => {
  const exists = list.includes(user);
  return exists ? list.filter((u) => u !== user) : [...list, user];
};

export const formatToMillion = (value) => {
  if (value === null || value === undefined) return "";

  return Number(value).toLocaleString("en-US");
};